import React from 'react';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { editando } from '../../actions/generalActios';
import { getGrupoPlanes, getGrupoPlanesById } from '../../api/axios';
import {
    setId,
    setPlanes,
    fetchGrupoPlanes,
    fetchGrupoPlanesById,
    setPlanesDesdeBusqueda,
    setDataGrupoCopy,
    setDataGrupo
} from '../../actions/planesActions';
import PlanesListItem from './PlanesListItem';
import FiltroGrupoPlanes from './FiltroGrupoPlanes';
import BtnToggleFilter from "../General/Filter/BtnToggleFilter";
import BigSpinner from "../General/BigSpinner";
import ReactExport from "react-export-excel";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


class ListPlanes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            onFilter: false,
            hideNoHay: false,
            numeroPagina: 1,
            cantidadPagina: 10,
            listaGrupoPlanes: null,
            listaPlanesDeGrupos: null,
            datosExcelFormateados: null
        }
    };

    componentDidMount() {
        this.busquedaGrupoPlanes({
            numeroPagina: this.state.numeroPagina,
            cantidadPagina: this.state.cantidadPagina
        });
    }

    onPlanesChange = (cantidad) => {
        if (cantidad > 0) this.setState({ hideNoHay: true });
        else this.setState({ hideNoHay: false });
    }

    busquedaGrupoPlanes = async (request) => {
        let params = request;
        await this.props.fetchGrupoPlanes({ params });
        
        if (this.props.userType.isAdminMod) {
            this.busquedaGrupoPlanesParaExcel(params);
        }
    }

    busquedaGrupoPlanesParaExcel = (params) => {
        const req = getGrupoPlanes({
            cantidadPagina: 500,
            numeroPagina: params.numeroPagina,
            descripcion: params.descripcion
        });

        req.then(res => {
            this.setState({ listaGrupoPlanes: res.data.elementos });
            let listaPlanes = [];
            const cantidadTotalGrupos = res.data.cantidadTotal;

            for (let index = 0; index < res.data.cantidadTotal; index++) {
                const idGrupoPlan = res.data.elementos[index].idGrupoPlan;
                const req = getGrupoPlanesById({ idGrupoPlan: idGrupoPlan });

                req.then(res => {
                    if (typeof res != 'string') {
                        if (typeof res.data != 'string') {
                            res.data["planGrupo"] = index;
                            listaPlanes.push(res.data)
                            if (listaPlanes.length == cantidadTotalGrupos) {
                                this.setState({ listaPlanesDeGrupos: listaPlanes });
                                this.setDatosExcelFormateados();
                            }
                        }
                    }
                })
            }
        }).catch(err => { })
    }

    setDatosExcelFormateados = () => {
        const listaGrupoPlanes = this.state.listaGrupoPlanes;
        const listaPlanesDeGrupo = this.state.listaPlanesDeGrupos;

        let indexGrupo = 0;
        let indexPlanes = 0;
        let grupo = [];
        let listaGrupo = [];

        if (Array.isArray(listaPlanesDeGrupo)) {
            for (indexGrupo = 0; indexGrupo < listaGrupoPlanes.length; indexGrupo++) {
                for (indexPlanes = 0; indexPlanes < listaPlanesDeGrupo.length; indexPlanes++) {
                    if (listaPlanesDeGrupo[indexPlanes].planGrupo === indexGrupo) {
                        grupo = listaGrupoPlanes[indexGrupo];
                        grupo["planes"] = listaPlanesDeGrupo[indexPlanes];
                        listaGrupo.push(grupo);
                    }
                }
            }
        }

        let cambioPlanes = [];
        let c = 0;
        while (listaGrupo.length > c) {
            for (let i = 0; i < listaGrupo[c].planes.elementos.length; i++) {
                let cambioPlan = [];
                cambioPlan["comision"] = listaGrupo[c].comision;
                cambioPlan["descripcion"] = listaGrupo[c].descripcion;
                cambioPlan["idGrupoPlan"] = listaGrupo[c].idGrupoPlan;
                cambioPlan["numeroPlan"] = listaGrupo[c].planes.elementos[i].numeroPlan;
                cambioPlan["descripcionPlan"] = listaGrupo[c].planes.elementos[i].descripcion;
                cambioPlanes.push(cambioPlan);
            }
            c++;
        }

        this.setState({ datosExcelFormateados: cambioPlanes });
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        this.busquedaGrupoPlanes({
            numeroPagina: selectedPage,
            cantidadPagina: this.state.cantidadPagina
        });
    };

    onGrupoPlan = (id) => {
        this.props.editando(true);
        this.props.setPlanesDesdeBusqueda([]);
        this.props.setDataGrupoCopy({})
        this.props.setPlanes([]);
        this.props.setId(id);
        this.props.history.push(`/Planes/Editar/${id}`);
    }

    goToPlanesNuevo = () => {
        this.props.fetchGrupoPlanesById({ idGrupoPlan: 0 });
        this.props.setDataGrupo({ descripcion: "", comision: "" });
        this.props.setPlanesDesdeBusqueda([]);
        this.props.setId(0);
        this.props.editando(false);
        setTimeout(() => { this.props.history.push("/Planes/Nuevo"); }, 500)
    }

    setFilter = (e) => {
        e.preventDefault();
        this.setState({ onFilter: !this.state.onFilter });
    }


    render() {
        const { grupoPlanes } = this.props;

        return (
            <div className="container">
                <div className="row align-items-center justify-content-between page-titles">

                    <div className="col-2">
                        <h3 className="text-themecolor color-rojo-megatone">Planes</h3>
                    </div>

                    <div className="button-group col-10 text-end">
                        {this.props.userType.isAdminMod &&
                            <ExcelFile
                                filename="Grupo Planes"
                                element={
                                    <button
                                        type="button"
                                        disabled={this.state.datosExcelFormateados === null}
                                        className="btn btn-sm btn-green"
                                    >
                                        Excel
                                    </button>
                                }
                            >
                                <ExcelSheet data={this.state.datosExcelFormateados} name="grupoPlanes">
                                    <ExcelColumn label="ID" value="idGrupoPlan" />
                                    <ExcelColumn label="Descripción Grupo de Planes" value="descripcion" />
                                    <ExcelColumn label="Comisión" value="comision" />
                                    <ExcelColumn label="Número plan" value="numeroPlan" />
                                    <ExcelColumn label="Descripción plan" value="descripcionPlan" />
                                </ExcelSheet>
                            </ExcelFile>
                        }

                        <button
                            type="button"
                            onClick={this.goToPlanesNuevo}
                            className="btn btn-sm btn-green"
                        >
                            <i className="fa fa-plus-circle mx-1" /> Crear Grupo
                        </button>

                        <BtnToggleFilter
                            show={this.state.onFilter}
                            handleShow={() => this.setState({ onFilter: !this.state.onFilter })}
                        />

                    </div>
                </div>

                <div hidden={!this.state.onFilter}>
                    <FiltroGrupoPlanes className="col-12" updateParams={this.busquedaGrupoPlanes} />
                </div>

                <div hidden={!this.state.hideNoHay}>
                    <h5 className="d-flex justify-content-center m-t-40 m-b-40">No hay grupo de planes</h5>
                </div>

                {this.props.isLoading ? <BigSpinner /> :
                    <>
                        {grupoPlanes &&
                            grupoPlanes.map((plan, i) => {
                                return (
                                    <div className="list-group" key={i}>
                                        <a onClick={() => this.onGrupoPlan(plan.idGrupoPlan)}>
                                            <PlanesListItem
                                                idGrupo={plan.idGrupoPlan}
                                                nombre={plan.descripcion}
                                                comision={plan.comision}
                                            />
                                        </a>
                                    </div>
                                );
                            })
                        }
                    </>
                }

                <div className="d-flex justify-content-center">
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={this.props.cantidadTotal / 10}
                        marginPagesDisplayed={10}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={0}
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    seller: state.general.idSeller,
    userType: state.general.userType,
    isLoading: state.planes.loadingPlanes,
    grupoPlanes: state.planes.grupoPlanes.elementos,
    cantidadTotal: state.planes.grupoPlanes.cantidadTotal,
});

export default connect(mapStateToProps, {
    setId,
    editando,
    setPlanes,
    setDataGrupo,
    setDataGrupoCopy,
    fetchGrupoPlanes,
    fetchGrupoPlanesById,
    setPlanesDesdeBusqueda
})(ListPlanes);